function showOptions(selectElement) {
  const selectedDepartment = selectElement[selectElement.selectedIndex].id;
  const departmentClass = "." + selectedDepartment;

  document.querySelectorAll(".all-roles").forEach((element) => {
    element.classList.remove("active");
    element.classList.add("hidden");
  });

  document.querySelectorAll(departmentClass).forEach((element, index) => {
    element.classList.add("active");
    if (index < 3) {
      element.classList.remove("hidden");
    }
  });

  const viewMoreButton = document.querySelector(".view-more-button");
  if (viewMoreButton && viewMoreButton.hasAttribute("data-view-less")) {
    viewMoreButton.textContent = "View More";
    viewMoreButton.removeAttribute("data-view-less");
  }
}

document.querySelector(".view-more-button")?.addEventListener("click", function () {
    if (this.hasAttribute("data-view-less")) {
      document
        .querySelectorAll(".career--table-row.active")
        .forEach((element, index) => {
          if (index > 2) {
            element.classList.add("hidden");
          }
        });
      this.querySelector(".view-more_text").textContent = "View More";
      this.removeAttribute("data-view-less");
    } else {
      document
        .querySelectorAll(".career--table-row.hidden.active")
        .forEach((element, index) => {
          if (index < 3) {
            element.classList.remove("hidden");
          }
        });
      if (
        document.querySelectorAll(".career--table-row.hidden.active").length ===
        0
      ) {
        this.querySelector(".view-more_text").textContent = "View Less";
        this.setAttribute("data-view-less", "true");
      }
    }
  });
